
$(function () {
    $(document).on("click", ".embed .toggle-close", function () {
        toggleEmbed($(this));
    });
    $(document).on("click", ".sgkContentGoogleMaps,.sgkGoogleMaps .btn", function () {
        var embed = $(this).closest(".embed");
        embed.find(".btn").toggleClass("d-none");
        loadEmbed(embed, $(this).hasClass("btn-primary"));
    });
    $(".embed").each(function () {
        if (localStorage.getItem("embed-" + $(this).data("embed")) !== null) {
            loadEmbed($(this), JSON.parse(localStorage.getItem("embed-" + $(this).data("embed"))));
        }
    });
})

function toggleEmbed(embed) {
    console.log("toggleEmbed");
    embed = embed.closest(".embed");
    embed.find(".info").toggleClass('invisible');
    //embed.find(".fa").toggleClass("fa-close fa-info");
    return embed;
}

function loadEmbed(embed, show) {
    //console.log("loadEmbed");
    //console.log(embed);
    localStorage.setItem("embed-" + embed.data("embed"), JSON.stringify(show));
    

    if (show) {
        //console.log("shop");
        embed.addClass("embeded");
        var embed = toggleEmbed(embed);
        embed.find(".btn").toggleClass("d-none");

        var s = document.createElement('script');
        s.setAttribute('src', embed.data("jssrc"));
        document.body.appendChild(s);

    } else {
        embed.removeClass("embeded");
    }

    

    var find = embed.find("iframe,script");
    if (find.length > 0) {
        find.attr("src", show ? find.data("src") : "");
        console.log("set" + find.data("src"));
    }
}


function initMap() {
    var center = { lat: 50.670580, lng: 9.880269 };
    var zoom = 6;
    if ($("#map").data("lat")) {
        center.lat = $("#map").data("lat");
        center.lng = $("#map").data("lng");
    }
    if ($("#map").data("zoom")) {
        zoom = $("#map").data("zoom");
    }
    var map = new google.maps.Map(document.getElementById('map'), {
        zoom: zoom,
        streetViewControl: false,
        mapTypeControl: false,
        center: center
    });

    setExpertMarkers(map, document.getElementById('map').dataset.experttype);

}


//This would be faster but wont work on IOS

//document.addEventListener("DOMContentLoaded", function () {
//    var lazyMaps = [].slice.call(document.querySelectorAll("#map"));

//    if ("IntersectionObserver" in window) {
//        let lazyMapObserver = new IntersectionObserver(function (entries, observer) {
//            entries.forEach(function (entry) {
//                if (entry.isIntersecting) {
//                    var map = new google.maps.Map(document.getElementById('map'), {
//                        zoom: 6,
//                        streetViewControl: false,
//                        mapTypeControl: false,
//                        center: { lat: 50.670580, lng: 9.880269 }
//                    });

//                    setExpertMarkers(map, document.getElementById('map').dataset.experttype);
//                    lazyMapObserver.unobserve(entry.target);
//                }
//            });
//        });

//        lazyMaps.forEach(function (lazyImage) {
//            lazyMapObserver.observe(lazyImage);
//        });
//    } else {
//        // Possibly fall back to event handlers here
//    }
//});


function setExpertMarkers(map, expertType) {

    var image = '/Images/MarkerIcon.png';


    $.ajax({
        type: "POST",
        contentType: "application/json; charset=utf-8",
        url: "/Handler/ExpertMapsHandler.ashx",
        data: JSON.stringify({
            action: "experts",
            type: expertType
        }),
        dataType: 'json',
        success: function (data) {

            const infoWindow = new google.maps.InfoWindow({
                content: "",
                disableAutoPan: true,
            });
            // Create an array of alphabetical characters used to label the markers.
            const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";


            const markers = data.map((position, i) => {

                const marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    icon: image,
                    title: position.label
                });

                // markers can only be keyboard focusable when they have click listeners
                // open info window when marker is clicked
                marker.addListener("click", () => {
                    infoWindow.setContent('<a href="' + position.lnk + '" class="d-block text-dark" style="width:280px;overflow:hidden"><div class="row align-items-center"><div class="col-6"><img src="' + position.img + '" class="img-fluid" style="max-width:100% !important" alt=""/></div><div class="col-6 text-break"><strong>' + position.label + '</strong/></div></div></a>');
                    infoWindow.open(map, marker);
                });
                return marker;
            });

            var renderer = {
                render: function (cluster, stats) {
                    const color = "#82aa21";
                    count = cluster.count;
                    // create svg url with fill color
                    const svg = window.btoa(`
<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
  <circle cx="120" cy="120" opacity=".6" r="70" />
  <circle cx="120" cy="120" opacity=".3" r="90" />
  <circle cx="120" cy="120" opacity=".2" r="110" />
  <circle cx="120" cy="120" opacity=".1" r="130" />
</svg>`);
                    var position = cluster.position;
                    // create marker using svg icon
                    return new google.maps.Marker({
                        position,
                        icon: {
                            url: `data:image/svg+xml;base64,${svg}`,
                            scaledSize: new google.maps.Size(45, 45),
                        },
                        label: {
                            text: String(count),
                            color: "rgba(255,255,255,0.9)",
                            fontSize: "12px",
                        },
                        // adjust zIndex to be above other markers
                        zIndex: 1000 + count,
                    });
                }
            }
            new markerClusterer.MarkerClusterer({
                markers, map, renderer
            });

            //for (var i = 0; i < data.length; i++) {
            //    var expert = data[i];
            //    var marker = new google.maps.Marker({
            //        position: { lat: expert[1], lng: expert[2] },
            //        map: map,
            //        icon: image,
            //        title: expert[0]
            //    });
            //    markers.add(marker);
            //}
            //new MarkerClusterer({ markers, map });

        }
    });
}